// extracted by mini-css-extract-plugin
export default {"project-name":"map-project-name_project-name__PBrXa"};